import React from 'react';
import { isEmpty } from 'lodash';
import { Row, Col } from 'react-flexbox-grid';
import {
  Section,
  Image,
  FullwidthImage,
  ImageMosaic,
  Paragraph,
  Link,
  Button,
  RelatedArticles,
} from 'components';
import { Intro, Summary, Fame, ClientReview, Statistics } from '..';
import { getCloudinaryUrl, toHtml } from 'config/helpers';
import '../../SingleCaseStudy.scss';

const CaseStudyContent = ({ data, articlesList }) => {
  const {
    mainVideo,
    cover,
    lead,
    title,
    mainColor,
    intro: summary,
    mainContent,
    settings,
  } = data;
  const { media, awards } = summary;
  const {
    review,
    workshopImage,
    statistics,
    solutionFinalImage,
    related,
  } = mainContent;

  return (
    <div className={'case-study-content'}>
      <Intro
        video={mainVideo || ''}
        cover={cover || ''}
        lead={lead || ''}
        title={title || ''}
        mainColor={mainColor || ''}
      />
      {summary && <Summary data={summary} mainColor={mainColor || ''} />}

      {media && <Fame media={media} />}

      <Section additionalClass={'case-study-content__section--'}>
        <Row className={'no-gap'}>
          <Col sm={12} md={8}>
            <div className={'case-study-content__section'}>
              {mainContent.client ? toHtml(mainContent.client) : ''}
            </div>
          </Col>
          <Col sm={12} md={4} className={'case-study-content__side-image'}>
            <Image
              src={mainContent.sideImage ? mainContent.sideImage : ''}
              alt={`${title || ''} - Boldare in Media`}
            />
          </Col>
        </Row>
      </Section>
      {awards && <Fame awards />}
      <Section spaceless>
        <Row className={'no-gap'}>
          <Col sm={12} md={8}>
            <div
              className={
                'case-study-content__section case-study-content__section--spaced'
              }
            >
              {mainContent.problem ? toHtml(mainContent.problem) : ''}
            </div>
          </Col>
        </Row>
      </Section>

      {workshopImage && (
        <FullwidthImage
          image={getCloudinaryUrl(workshopImage, 'f_auto,q_auto,w_1920')}
          alt={`${title} - Boldare Team`}
          side={'right'}
        />
      )}

      <Section>
        <Row className={'no-gap'}>
          <Col sm={12} md={8}>
            <div className={'case-study-content__section'}>
              {mainContent.solutionFirst
                ? toHtml(mainContent.solutionFirst)
                : ''}
            </div>
          </Col>
        </Row>
      </Section>

      {mainContent.processImages && !isEmpty(mainContent.processImages) && (
        <ImageMosaic images={mainContent.processImages} />
      )}

      <Section>
        <Row className={'no-gap'}>
          <Col sm={12} md={8}>
            <div className={'case-study-content__section'}>
              {mainContent.solutionSecond
                ? toHtml(mainContent.solutionSecond)
                : ''}
            </div>
          </Col>
        </Row>
      </Section>

      {mainContent.productImages && !isEmpty(mainContent.productImages) && (
        <ImageMosaic images={mainContent.productImages} />
      )}

      <Section>
        <Row className={'no-gap'}>
          <Col sm={12} md={8}>
            <div className={'case-study-content__section'}>
              {mainContent.solutionThird
                ? toHtml(mainContent.solutionThird)
                : ''}
            </div>
          </Col>
        </Row>
      </Section>

      {solutionFinalImage && (
        <FullwidthImage
          image={getCloudinaryUrl(solutionFinalImage, 'f_auto,q_auto,w_1920')}
          alt={`${title} - Boldare Solution`}
          side={'right'}
        />
      )}

      <Section>
        <Row className={'no-gap'}>
          <Col sm={12} md={8}>
            <div className={'case-study-content__section'}>
              {mainContent.results ? toHtml(mainContent.results) : ''}
            </div>
          </Col>
        </Row>
      </Section>

      {review && <ClientReview data={review} mainColor={mainColor} />}

      {statistics && <Statistics data={statistics} mainColor={mainColor} />}

      <Section>
        <Row className={'no-gap'}>
          <Col sm={12} md={8}>
            <div className={'case-study-content__section'}>
              {mainContent.resultsSecond
                ? toHtml(mainContent.resultsSecond)
                : ''}
            </div>
          </Col>
        </Row>
      </Section>

      <Section spaceless additionalClass={'case-study-content__cta'}>
        <div className={'case-study-content__contact anim-fade-in-bottom'}>
          <Link to={'/contact#form'}>
            <Paragraph
              size={'big'}
              color={'yellow'}
              additionalClass={'text--bold'}
            >
              {"Let's"} talk
            </Paragraph>
            <Paragraph
              color={'white'}
              size={'medium'}
              additionalClass={'contact__content'}
            >
              {"We'd"} love to help with your product. Get in touch.
            </Paragraph>
            <Button
              id={`contact-cs-${settings.slug}`}
              transparent
              color={'white'}
            >
              Contact
            </Button>
          </Link>
        </div>
      </Section>

      {!(isEmpty(articlesList) || isEmpty(related)) && (
        <RelatedArticles
          id={'cs-related'}
          related={related}
          allArticles={articlesList}
        />
      )}
    </div>
  );
};

export default CaseStudyContent;
